/* RETREATURE - Umschalter fuer den gekuerzten Kurztext auf der Produktseite.
   Gehoert zu assets/rt-pdp.css, 10.09.2026.

   Die Kuerzung auf zwei Zeilen macht das Stylesheet. Hier kommt nur der
   Knopf dazu. Sein Platz ist im CSS bereits reserviert, deshalb verschiebt
   das Einfuegen nichts. Ist der Text ohnehin kuerzer als zwei Zeilen, wird
   der Knopf unsichtbar geschaltet statt entfernt - so bleibt die Hoehe
   gleich und es entsteht auch dann kein Sprung. */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var absatz = document.querySelector('.product__top .product__small-description');
  if (!absatz || !absatz.textContent.trim()) return;

  var knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'rt-mehr';
  knopf.textContent = 'mehr lesen';
  knopf.setAttribute('aria-expanded', 'false');

  var id = absatz.id || 'rt-produkttext';
  absatz.id = id;
  knopf.setAttribute('aria-controls', id);

  absatz.insertAdjacentElement('afterend', knopf);

  // Nur anzeigen, wenn wirklich etwas abgeschnitten ist.
  if (absatz.scrollHeight <= absatz.clientHeight + 2) {
    knopf.classList.add('rt-mehr--leer');
    knopf.setAttribute('aria-hidden', 'true');
    knopf.tabIndex = -1;
    return;
  }

  knopf.addEventListener('click', function () {
    var offen = absatz.hasAttribute('data-rt-offen');
    if (offen) {
      absatz.removeAttribute('data-rt-offen');
      knopf.textContent = 'mehr lesen';
      knopf.setAttribute('aria-expanded', 'false');
    } else {
      absatz.setAttribute('data-rt-offen', '');
      knopf.textContent = 'weniger';
      knopf.setAttribute('aria-expanded', 'true');
    }
  });
});
